    <!-- <h1>Supplier Gateway</h1> -->
    <!-- <hr>
    <hr>
    <img src="assets/Images/HomersOnJob.jpg" width="500" height="500">
    <hr>
    <hr> -->
<app-downtime-banner></app-downtime-banner>
<section *ngIf="isPageReadyToDisplay">
    <div class="row margin-top-bottom">
        <div class="col-6">
          <h4 class="sg-page-title pl-3">Home</h4>
        </div>
    </div>
</section>
<section *ngIf="isPageReadyToDisplay">
  <div class="row mx-0">
    <div class="col-4">
      <app-news-updates-preview [pageContents]="pageContents"></app-news-updates-preview>
    </div>
    <div class="offset-1 col-7">
      <app-news-updates-details [pageContents]="pageContents"></app-news-updates-details>
    </div>
  </div>
</section>
<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
  <mat-spinner></mat-spinner>
</div>
